var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"home-services"},[_c('div',{staticClass:"home-services-cnt"},[_c('div',{staticClass:"background-cnt"}),_c('div',{staticClass:"items-cnt"},_vm._l((_vm.services),function(service){return _c('ServiceItem',{key:service.id,attrs:{"service":service}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }